import Vue from 'vue'
import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllDevices ({ commit }) {
    api.getDevices(devices => {
      commit('setDevices', devices)
    })
  }
}

const mutations = {
  updateDevice (state, options) {
    Vue.set(state.all, options.index, options.item)
  },
  setDevices (state, devices) {
    state.all = devices
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/devices.js